import React, { useState } from "react";
import { useSelector } from "react-redux";
import { CustomersItemContainer } from "./CustomersItemContainer";
import { useProductsData } from "../menu/products/useProductsData";
import APIExtensions from "../../yoello-lib/modules/API2/APIDefs";
import { IReduxAppState } from "../../reducers";
import { useSideTabs } from "../../hooks/useSideTabs";
import { DisableRouteComponent } from '../util/DisableRouteComponent';
import { IListItem } from "./types.d"
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { MultiDialogRoute } from "../dialogRoutes/MultiDialogRoute";
import Styles from "../../scss/orderDetails.module.scss"
import { CustomerDialog } from "./CustomerDialog";
import { OrderDetailsDialog } from "../orders/Dialogs/OrderDetailsDialog";
import { BY_ID, dialogKeys, ORDERS_URL } from "../../const/URL.const";

export function CustomerDetailsContainer(props: any) {
    const [customersList, setCustomersList] = useState<IListItem[]>([]);
    const position = useSideTabs(props.tab);
    const venueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const { callAPI, isLoading } = useProductsData(APIExtensions.customersDetails, venueId, setCustomersList, {}, "orders");
    let { path } = useRouteMatch();

    return <Switch>
        <DisableRouteComponent pageKey={position}>
            <Route path={path}>
                <CustomersItemContainer
                    isLoading={isLoading}
                    customersList={customersList}
                    venueId={venueId}
                    callCustomersAPI={callAPI}
                    path={path}
                />
                <MultiDialogRoute
                    RouteSteps={[
                        {
                            key: dialogKeys.CUSTOMER,
                            Component: CustomerDialog,
                            path: `${path}${BY_ID}`,
                            exact: true,
                            dialogClassName: Styles.OrderHistoryPageDialog,
                            title: "customers.customersContainer.customerDetalis",
                            isFormDialog:false
                        },
                        {
                            key: dialogKeys.ORDER,
                            Component: OrderDetailsDialog,
                            path: `${path}${ORDERS_URL}${BY_ID}`,
                            dialogClassName: Styles.OrderHistoryPageDialog,
                            title: "orderHistory.modal.title",
                            isFormDialog:false
                        }
                    ]}
                    navigateBackRotue={path}
                />
            </Route>
        </DisableRouteComponent>
    </Switch>
}